import React from 'react';
import { DialogActions, Button, Box } from '@mui/material';

interface DialogActionButtonsProps {
    isEditing: boolean;
    canDelete: boolean;
    isSubmitting: boolean;
    isDeleting: boolean;
    onDelete: () => void;
    onCancel: () => void;
    onSubmit: () => void;
}

export const DialogActionButtons: React.FC<DialogActionButtonsProps> = ({
    isEditing,
    canDelete,
    isSubmitting,
    isDeleting,
    onDelete,
    onCancel,
    onSubmit
}) => {
    return (
        <DialogActions>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                <Box>
                    {isEditing && canDelete && (
                        <Button
                            onClick={onDelete}
                            color="error"
                            disabled={isSubmitting || isDeleting}
                        >
                            {isDeleting ? 'Deleting...' : 'Delete'}
                        </Button>
                    )}
                </Box>
                <Box sx={{ display: 'flex', gap: 1 }}>
                    <Button onClick={onCancel} disabled={isSubmitting || isDeleting}>
                        Cancel
                    </Button>
                    <Button
                        onClick={onSubmit}
                        variant="contained"
                        disabled={isSubmitting || isDeleting}
                    >
                        {isSubmitting ? 'Saving...' : isEditing ? 'Update CPT' : 'Add CPT'}
                    </Button>
                </Box>
            </Box>
        </DialogActions>
    );
};
